import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {Select, Store} from '@ngxs/store';
import {Observable} from 'rxjs/internal/Observable';
import {GetOrderHistoryList} from '../../../../shared/states/orders/orders.actions';
import {OrdersState} from '../../../../shared/states/orders/orders.state';
import {IOrdersHistory} from '../../../../shared/interfaces/orders-history.inteface';
import {getDateFromISO, getUTC} from '../../../../shared/helpers/helpers';
import {SearchInputColorEnum} from '../../../../shared/components/search-input/search-input.component';
import {OrderHistoryStatusesEnum} from '../../../../shared/interfaces/OrderHistoryStatusesEnum';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {distinctUntilChanged, startWith} from 'rxjs/operators';
import {Router} from '@angular/router';
import { AlertMessageService } from 'src/app/shared/services/alert-message.service';
import { AlertTypesEnum } from 'src/app/shared/interfaces/AlertTypesEnum';

@UntilDestroy()
@Component({
  selector: 'app-order-history-page',
  templateUrl: './order-history-page.component.html',
  styleUrls: ['./order-history-page.component.scss', './../../../inventory.scss'],
})
export class OrderHistoryPageComponent implements OnInit {
  orderHistoryControlsForm: UntypedFormGroup;

  SearchInputColorEnum = SearchInputColorEnum;

  currentTab: OrderHistoryStatusesEnum = OrderHistoryStatusesEnum.All;

  ordersHistoryAll: IOrdersHistory[] = [];
  ordersHistoryReceived: IOrdersHistory[] = [];
  ordersHistoryNotReceived: IOrdersHistory[] = [];

  ordersHistoryAllFiltered: IOrdersHistory[] = [];
  ordersHistoryReceivedFiltered: IOrdersHistory[] = [];
  ordersHistoryNotReceivedFiltered: IOrdersHistory[] = [];

  OrderHistoryStatusesEnum = OrderHistoryStatusesEnum;

  @Select(OrdersState.ordersHistoryList) ordersHistoryList$: Observable<IOrdersHistory[]>;
  @Select(OrdersState.loading) loading$: Observable<boolean | undefined>;

  getDateFromISO = getDateFromISO;
  navigation: any;

  constructor(
    private fb: UntypedFormBuilder,
    private store: Store,
    private router: Router,
    private notificationService: AlertMessageService,
  ) {
    this.navigation = router.getCurrentNavigation();
    this.orderHistoryControlsForm = this.fb.group({
      searchValue: ['', []],
    });
  }

  ngOnInit(): void {
    this.setNotReceiveAsActiveTabIfRequested();
    this.store.dispatch(new GetOrderHistoryList(''));
    this.ordersHistoryList$
      .pipe(untilDestroyed(this))
      .subscribe((data: IOrdersHistory[]) => {
        data = data?.map(order => { 
          return {...order, shippedDate: getUTC(order?.shippedDate)}
        }) || [];

        this.ordersHistoryAll = [...data];
        this.ordersHistoryReceived = [...data.filter(el => el.orderStatus === OrderHistoryStatusesEnum.Received)];
        this.ordersHistoryNotReceived = [...data.filter(el => el.orderStatus === OrderHistoryStatusesEnum.NotReceived)];

        this.ordersHistoryAllFiltered = [...this.ordersHistoryAll];
        this.ordersHistoryReceivedFiltered = [...this.ordersHistoryReceived];
        this.ordersHistoryNotReceivedFiltered = [...this.ordersHistoryNotReceived];
      });

    this.orderHistoryControlsForm.get('searchValue')?.valueChanges
      .pipe(
        untilDestroyed(this),
        startWith(''),
        distinctUntilChanged(),
      )
      .subscribe((search: string) => {
        console.log(search)
        this.filterBySearchValue(search);
      });

    if (this.navigation?.extras?.state?.bulkAdded) {
      this.tabChanged(OrderHistoryStatusesEnum.Received);
      setTimeout(() => {
        this.notificationService
        .displayAlert(`Successfully added ${this.navigation?.extras.state.bulkAdded} NDC${this.navigation?.extras.state.bulkAdded !== 1 ? 's' : ''} to inventory.`,
          AlertTypesEnum.Success);
      });
    }
  }

  tabChanged(tab: OrderHistoryStatusesEnum): void {
    this.currentTab = tab;
  }

  filterBySearchValue(searchString: string): void {
    const searchStr = searchString?.trim()?.toLowerCase();
    const filterFunction = (search, data) => searchString ?
    data.filter(el => el?.wholesalerName.toLowerCase().includes(searchStr) ||
    el.purchaseOrder?.toLowerCase()?.includes(searchStr) ||
    el.invoiceNumber?.toLowerCase()?.includes(searchStr) ||
    el?.csos?.toLowerCase()?.includes(searchStr)
  ) : data;
  
  this.ordersHistoryAllFiltered = filterFunction(searchString, [...this.ordersHistoryAll]);
  this.ordersHistoryReceivedFiltered = filterFunction(searchString, [...this.ordersHistoryReceived]);
  this.ordersHistoryNotReceivedFiltered = filterFunction(searchString, [...this.ordersHistoryNotReceived]);
  }

  private setNotReceiveAsActiveTabIfRequested(): void {
    const navigationState = this.navigation?.extras?.state;

    if (navigationState?.shouldRedirectToNotReceived) {
      this.currentTab = OrderHistoryStatusesEnum.NotReceived;
    }
  }
}
